import { c as _c } from "react/compiler-runtime";
import type { PrV2MarkerDetectedAgent } from '@/lib/pr-v2/types';
import { AiAttributionDetectedAgentsList } from './ai-attribution-detected-agents-list';
import { AiAttributionToolRow } from './ai-attribution-tool-row';
import { isUnknownModel, selectMarkerOnlyAgents } from './ai-attribution-utils';
import { getModelIcon, getToolIcon } from '@/components/icons/ai-providers';
type ToolEntry = {
  tool: string;
  model: string;
  linesAdded: number;
};
type AiAttributionToolsListProps = {
  tools: ToolEntry[];
  detectedAgents: PrV2MarkerDetectedAgent[];
};
export function AiAttributionToolsList(t0) {
  const $ = _c(15);
  const {
    tools,
    detectedAgents
  } = t0;
  let t1;
  if ($[0] !== detectedAgents || $[1] !== tools) {
    t1 = selectMarkerOnlyAgents(tools, detectedAgents);
    $[0] = detectedAgents;
    $[1] = tools;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const markerOnlyAgents = t1;
  if (tools.length === 0 && markerOnlyAgents.length === 0) {
    return null;
  }
  const totalLines = tools.reduce(_temp, 0);
  const showPercent = tools.length > 1 && totalLines > 0;
  let t2;
  if ($[3] !== showPercent || $[4] !== tools || $[5] !== totalLines) {
    let t3;
    if ($[7] !== showPercent || $[8] !== totalLines) {
      t3 = entry => {
        const percent = showPercent ? Math.round(entry.linesAdded / totalLines * 100) : null;
        const hasModel = !isUnknownModel(entry.model);
        return <AiAttributionToolRow key={`${entry.tool}-${entry.model}`} tool={entry.tool} model={entry.model} percent={percent} ToolIcon={getToolIcon(entry.tool)} ModelIcon={hasModel ? getModelIcon(entry.model) : null} />;
      };
      $[7] = showPercent;
      $[8] = totalLines;
      $[9] = t3;
    } else {
      t3 = $[9];
    }
    t2 = tools.map(t3);
    $[3] = showPercent;
    $[4] = tools;
    $[5] = totalLines;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[10] !== markerOnlyAgents) {
    t3 = markerOnlyAgents.length > 0 ? <><div className="pt-1 text-[10px] text-zinc-500">Also detected (markers)</div><AiAttributionDetectedAgentsList agents={markerOnlyAgents} testId="pr-v2-ai-code-marker-agents" /></> : null;
    $[10] = markerOnlyAgents;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== t2 || $[13] !== t3) {
    t4 = <div data-testid="pr-v2-ai-code-tools" className="space-y-1.5">{t2}{t3}</div>;
    $[12] = t2;
    $[13] = t3;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  return t4;
}
function _temp(sum, t) {
  return sum + t.linesAdded;
}